<template>
  <div>
    <v-row no-gutters class="mx-auto my-3">
      <v-col cols="12" class="mb-4 d-flex flex-wrap">
        <div v-for="(item, index) in designObject" :key="index">
          <div @click="chooseDesign(item.value)" class="m-2 p-3 qrBtn">
            <img :src="item.img" :alt="item.value">
          </div>
        </div>
      </v-col>

      <v-col cols="12" md="6" class="pa-2">
        <v-text-field outlined dense v-model="marker.text" label="متن اسکن" clearable
                      clear-icon="mdi-close-circle-outline"/>
      </v-col>

      <v-col cols="12" md="6" class="pa-2">
        <v-switch label="شخصی سازی رنگ فریم" class="ma-0" v-model="marker.different_markers_color"/>
      </v-col>

      <v-col cols="12" md="6" class="pa-2" v-if="marker.different_markers_color">
        <color-picker v-model="marker.main" label="رنگ مرکز"/>
      </v-col>
    </v-row>
  </div>


</template>

<script>
import ColorPicker from "@/view/pages/qrland/components/colorPicker";

export default {
  name: "qrFrame",
  components: {ColorPicker},
  data() {
    return {
      designObject: [
        {value: 'none', img: '/media/frame/none.svg'},
        {value: 'balloon-bottom', img: '/media/frame/baloon-bottom.svg'},
        {value: 'balloon-top', img: '/media/frame/baloon-top.svg'},
        {value: 'bottom', img: '/media/frame/bottom.svg'},
        {value: 'cine', img: '/media/frame/cine.svg'},
        {value: 'phone', img: '/media/frame/phone.svg'},
        {value: 'ribbon-bottom', img: '/media/frame/ribbon-bottom.svg'},
        {value: 'ribbon-top', img: '/media/frame/ribbon-top.svg'},
        {value: 'top', img: '/media/frame/top.svg'},
      ],
      marker: {
        main: '#000',
        text: 'SCAN ME',
        framePattern: 'none',
        different_markers_color: false
      },
    }
  },
  methods: {
    chooseDesign(value) {
      this.marker.framePattern = value
    }
  },
  watch: {
    marker: {
      handler(value) {
        this.$emit('input', value)
      },
      deep: true,
    }

  }
}
</script>

<style scoped>
.qrBtn {
  border-radius: 15px !important;
  box-shadow: 8px 5px 10px #02105c8c;
  cursor: pointer;
}

.qrBtn:hover {
  border-radius: 0 !important;
  box-shadow: none !important;
}
</style>